// SDK-docs pattern: sendMessage is synchronous and throws if the agent is busy
// (e.g. still running an icebreaker greeting). Recurse on mindset:agent-idle so
// callback always runs once the agent settles.
export function whenAgentIdle(agent, callback) {
  function run() {
    var _agent$isAgentBusy;
    if (!(agent !== null && agent !== void 0 && (_agent$isAgentBusy = agent.isAgentBusy) !== null && _agent$isAgentBusy !== void 0 && _agent$isAgentBusy.call(agent))) {
      callback();
    } else {
      agent.addEventListener('mindset:agent-idle', run, {
        once: true
      });
    }
  }
  run();
}